import * as yup from 'yup'

yup.addMethod(yup.number, 'lessOrEqualToField', function (ref, message) {
  return this.test('lessOrEqualToField', message, function (value) {
    return value <= this.resolve(ref)
  })
})

yup.addMethod(yup.number, 'greaterOrEqualToField', function (ref, message) {
  return this.test('lessOrEqualToField', message, function (value) {
    return value >= this.resolve(ref)
  })
})

const priceRangeSchema = (min, max) => yup.object({
  priceFrom: yup.number()
    .max(max, `Greater than ${max}`)
    .min(min, `Less than ${min}`)
    .nullable()
    .when('priceTo', {
      is: (priceTo) => priceTo !== null && priceTo !== undefined,
      then: (schema) => schema.lessOrEqualToField(yup.ref('priceTo'), 'Greater than Max price')
    }),
  priceTo: yup.number()
    .nullable()
    .test('priceTo-validation', function (value) {
      if (value === null || value === undefined) {
        return true
      }
      const { priceFrom } = this.parent
      if (value < min) {
        return this.createError({ message: `Less than ${min}` })
      }
      if (priceFrom !== null && priceFrom !== undefined && value < priceFrom) {
        return this.createError({ message: 'Less than Min price' })
      }
      return true
    })
})

export default priceRangeSchema
